import React, { Component } from "react";
import { connect } from "react-redux";

import TextDisplayWithCopyToClipboard from "./TextDisplayWithCopyToClipboard";
import { fetchUserDetail, adminUpdateUser } from "../actions/adminActions";

import { extractCognitoAttributesAsObject } from "../utilities/awsUtilities";

import {
	EditUserEmailWithValidation,
	EditDisplayNameWithValidation,
} from "./EditUserAttributesWithValidation";

import TwoColumnWrapper from "./TwoColumnWrapper";
import { IconUser, IconCopy } from "@tabler/icons-react";
import ButtonWithPopoverFeedback from "./ButtonWithPopoverFeedback";
import { isTenantSuspended } from "./Admin/firmStatusPill";
import { SuspendedFirmUsersMessage } from "./Utils/UnderSubHeaderWarningMessages";

class EditUser extends Component {
	constructor(props) {
		super(props);
		this.state = {
			emailAddress: "",
			username: "",
			displayName: "",
			sub: "",
			loading: true,
			original: {},
			dbOriginal: {},

			emailIsValid: false,
			displayNameIsValid: true,
			tenantID: null,
		};
		this.handleChange = this.handleChange.bind(this);
	}

	componentDidMount() {
		fetchUserDetail({
			manualTenantID: this.props.match.params.tenantID,
			userIdentifier: this.props.match.params.sub,
		}).then((res) => {
			const databaseUserInfo = res.mysql.db;
			const cognitoUserInfo = res.mysql.cognito;

			if (databaseUserInfo) {
				this.setState({
					loading: false,
					tenantID: databaseUserInfo.tenantID,
					dbOriginal: databaseUserInfo,
					tenantPlanType: res.mysql.tenantPlanType,
				});
			}
			if (cognitoUserInfo) {
				const { Attributes, Username } = cognitoUserInfo;
				const attributesObj =
					extractCognitoAttributesAsObject(Attributes);

				const username = Username;
				const emailAddress = attributesObj.email;
				const displayName = attributesObj.name;
				const sub = attributesObj.sub;

				this.setState({
					loading: false,
					...{ username, emailAddress, displayName, sub },
					original: { username, emailAddress, displayName },
				});
			} else {
				console.error("no user");
			}
		});
	}

	handleChange(key, value) {
		this.setState({ [key]: value });
	}

	submit() {
		const { username, emailAddress, displayName } = this.state;
		this.props.adminUpdateUser({
			username,
			emailAddress,
			displayName,
			tenantID: this.state.tenantID,
		});
	}
	render() {
		if (this.state.loading) {
			return (
				<div>
					<h1>
						Loading<span className="Loading">...</span>
					</h1>
				</div>
			);
		} else {
			const emailChanged =
				this.state.emailAddress !== this.state.original.emailAddress;

			const displayNameChanged =
				this.state.displayName !== this.state.original.displayName;

			const isSuspended = isTenantSuspended(this.state.tenantPlanType);

			return (
				<>
					{isSuspended ? SuspendedFirmUsersMessage() : null}
					<TwoColumnWrapper
						headingText="User Information"
						maxContentWidth={1000}
						iconComponent={
							<IconUser
								size={16}
								style={{ verticalAlign: "middle" }}
							/>
						}
						submit={this.submit.bind(this)}
						canSubmit={
							!isSuspended &&
							this.state.displayNameIsValid &&
							this.state.emailIsValid &&
							(emailChanged || displayNameChanged)
						}
						submitDisabledHoverText={
							isSuspended ? "This firm is suspended" : undefined
						}
						submitButtonText={"Update User"}
						leftChildren={
							<div>
								<div
									style={{
										display: "flex",
										alignItems: "flex-start",
										gap: 8,
									}}
								>
									<div style={{ flex: 1 }}>
										<EditDisplayNameWithValidation
											label="Display Name"
											name="displayName"
											disabled={isSuspended}
											defaultValue={
												this.state.original.displayName
											}
											onChange={this.handleChange}
											fieldIsValidAndReadyChanged={(
												displayNameIsValid
											) => {
												this.setState({
													displayNameIsValid,
												});
											}}
										/>
									</div>
									<ButtonWithPopoverFeedback
										onClick={() =>
											navigator.clipboard.writeText(
												this.state.displayName
											)
										}
										feedbackMessage="Copied to clipboard!"
										title="Copy display name"
										iconComponent={<IconCopy size={16} />}
										style={{ marginTop: 28 }}
									/>
								</div>
								<TextDisplayWithCopyToClipboard
									label="Username"
									value={this.state.username}
								/>
							</div>
						}
						rightChildren={
							<div>
								<div
									style={{
										display: "flex",
										alignItems: "flex-start",
										gap: 8,
									}}
								>
									<div style={{ flex: 1 }}>
										<EditUserEmailWithValidation
											label="Email Address"
											name="emailAddress"
											disabled={isSuspended}
											placeholder="test@example.com"
											onChange={this.handleChange}
											defaultValue={
												this.state.original.emailAddress
											}
											fieldIsValidAndReadyChanged={(
												emailIsValid
											) => {
												this.setState({
													emailIsValid,
												});
											}}
										/>
									</div>
									<ButtonWithPopoverFeedback
										onClick={() =>
											navigator.clipboard.writeText(
												this.state.emailAddress
											)
										}
										feedbackMessage="Copied to clipboard!"
										title="Copy email"
										iconComponent={<IconCopy size={16} />}
										style={{ marginTop: 28 }}
									/>
								</div>
								<TextDisplayWithCopyToClipboard
									label="Cognito Sub"
									value={this.state.sub}
								/>
							</div>
						}
					/>
				</>
			);
		}
	}
}

export default connect(() => ({}), {
	adminUpdateUser,
})(EditUser);
